<div class="modal-header">
  <p class="modal-title h4">{{ title }}</p>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="card-body">
    <div class="row">
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <span>Seleccione una Foto</span>
          <div class="form-group">
            <div class="holder">
              <input type="file" name="image" (change)="fileProgress($event)" />
            </div>
          </div>
          <!-- Progress Bar -->
          <div class="progress form-group" *ngIf="progress > 0">
            <div
              class="progress-bar progress-bar-striped bg-success"
              role="progressbar"
              [style.width.%]="progress"
            ></div>
          </div>

          <div *ngIf="fileUploadProgress">
            progreso: {{ fileUploadProgress }}
          </div>
          <div class="image-preview mb-3" *ngIf="previewUrl">
            <img [src]="previewUrl" height="300" />
          </div>

          <div class="mb-3" *ngIf="uploadedFilePath">
            {{ uploadedFilePath }}
          </div>

          <!--   <div class="form-group">
                    <button class="btn btn-primary" (click)="subirFoto()">
                      Subir la servidor
                    </button>
                  </div>-->
        </div>
      </div>
      <div class="col-md-12">
        <form
          action=""
          [formGroup]="clientForm"
          (ngSubmit)="registerClient()"
          class="form-horizontal form-material"
          id="categoryform"
          novalidate
        >
          <div class="form-group row m-t-20">
            <div class="col-xs-12 col-md-6">
              <app-form-error-wrapper
                [control]="clientForm.controls['nombres']"
                [controlName]="'Nombre '"
              >
                <label for="name"></label>
                <input
                  class="form-control"
                  type="text"
                  id="name"
                  formControlName="nombres"
                  placeholder="Nombre de Cliente"
                />
              </app-form-error-wrapper>
            </div>
            <div class="col-xs-12 col-md-6">
              <app-form-error-wrapper
                [control]="clientForm.controls['apellidos']"
                [controlName]="'Apellido '"
              >
                <label for="lastName"></label>
                <input
                  class="form-control"
                  type="text"
                  id="lastName"
                  formControlName="apellidos"
                  placeholder="Apellido de Cliente"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="clientForm.controls['ci_nit']"
                [controlName]="'CI '"
              >
                <input
                  class="form-control"
                  type="text"
                  formControlName="ci_nit"
                  placeholder="CI de Cliente"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="clientForm.controls['direccion']"
                [controlName]="'Direccion '"
              >
                <input
                  class="form-control"
                  type="text"
                  formControlName="direccion"
                  placeholder="Direccion de Cliente"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="clientForm.controls['email']"
                [controlName]="'Correo Electronico '"
              >
                <input
                  class="form-control"
                  type="email"
                  formControlName="email"
                  placeholder="Ejemplo@gmail.com"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="clientForm.controls['entidad']"
                [controlName]="'Entidad '"
              >
                <input
                  class="form-control"
                  type="text"
                  formControlName="entidad"
                  placeholder="Nombre de la tienda"
                />
              </app-form-error-wrapper>
            </div>
          </div>

          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="clientForm.controls['celular']"
                [controlName]="'N° de celular '"
              >
                <input
                  class="form-control"
                  type="number"
                  formControlName="celular"
                  placeholder="N° celular "
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="clientForm.controls['telefono']"
                [controlName]="'N° de Telefono '"
              >
                <input
                  class="form-control"
                  type="number"
                  formControlName="telefono"
                  placeholder="N° Telefono "
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group text-center m-t-20">
            <div class="col-xs-12">
              <button
                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                [disabled]="clientForm.invalid || isLoading"
              >
                <app-button-loader
                  [isLoading]="isLoading"
                  [label]="'Guardar'"
                ></app-button-loader>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-dark"
    (click)="activeModal.close('Close click')"
  >
    Cerrar
  </button>
</div>
